import {
  Cards,
  MenuItemsType,
  SwapIcon,
} from '@pancakeswap/uikit'
import { ContextApi } from 'contexts/Localization/types'
import LP from '@pancakeswap/uikit/src/components/Svg/Icons/LP'
import ArrowForward from "@pancakeswap/uikit/src/components/Svg/Icons/ArrowForward";
import SwapLight from '../../BotomICons/SwarpLight'
import SwapDark from '../../BotomICons/SwapDark'
import LpLight from '../../BotomICons/LpLight'
import LpDark from '../../BotomICons/LpDark'
import InvolitDark from '../../BotomICons/InvolitDark'
import InvoliLight from '../../BotomICons/InvolitLight'

export type ConfigMenuItemsType = MenuItemsType & { hideSubNav?: boolean }

const config: (t: ContextApi['t'], languageCode?: string) => ConfigMenuItemsType[] = (t, languageCode) => [
  {
    label: t('兑换'),
    icon: SwapDark,
    fillIcon: SwapLight,
    href: '/swap',
    showItemsOnMobile: false,
    items: [],
  },
  {
    label: t('邀请'),
    icon: InvolitDark,
    fillIcon: InvoliLight,
    href: '/invite',
    showItemsOnMobile: false,
    items: [],
  },
  {
    label: t('流动性'),
    icon: LpDark,
    fillIcon: LpLight,
    href: '/liquidity',
    showItemsOnMobile: false,
    items: [],
  }
]

export default config
